import React, { useState } from 'react';
import { Tooltip, ClickAwayListener, TooltipProps } from '@mui/material';

const CustomTooltip = ({
    children,
    title,
    ...rest
}: TooltipProps) => {
    const [ open, setOpen ] = useState(false);

    const handleClick = () => {
        setOpen(prev => !prev);
    };

    const handleClickAway = () => {
        setOpen(false);
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div>
                <Tooltip
                    {...rest}
                    title={title}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                >
                    <div onClick={handleClick}>
                        {children}
                    </div>
                </Tooltip>
            </div>
        </ClickAwayListener>
    );
};

export default CustomTooltip;